export const headersLanguageKey = 'TICKET_CLIENT_HEADERS_LANGUAGE'

export const dateTimeFormat = 'YYYY-MM-DD HH:mm'

export function dateTimeRules({
  rule,
  value,
  callback,
  // showZone = false,
  showZone = true,
  LOCALE
}) {
  // 字段的 fillFlag 已经控制了必填，这里的校验规则只管都有值的情况
  // 不显示时区时，直接通过
  if (!value || !showZone) {
    callback()
    return
  }
  // 没有逗号，且value的值是日期时间，没有时区
  if (!value.includes(',')) {
    callback(LOCALE['noZone'])
    return
  }
  const [zone, date] = value.split(',')
  // 有逗号，即有时区
  if (!zone && !date) {
    callback(LOCALE['required'])
    return
  }
  if (!zone) {
    callback(LOCALE['noZone'])
    return
  }
  if (!date) {
    callback(LOCALE['noDatetime'])
    return
  }
  callback()
}

export const getHeaderLanguage = (LOCALE_HTML) => {
  let language = ''
  switch (LOCALE_HTML) {
    case 'zh':
    case 'cn':
    case 'zh_CN':
    case 'zh-Hans':
      language = 'zh'
      break
    case 'tw':
    case 'zh_TW':
    case 'zh-Hant':
      language = 'zh-Hant'
      break
    default:
      language = LOCALE_HTML
        ? LOCALE_HTML?.match?.(/^(.*?)_/)?.[1] || LOCALE_HTML
        : 'zh'
      break
  }
  return language
}

export const getEditorLanguage = (LOCALE_HTML) => {
  const LOCALE_HTMLLanguage = LOCALE_HTML?.['msg.language'] || ''
  let editorLanguage = ''
  switch (LOCALE_HTMLLanguage) {
    case 'zh':
      editorLanguage = 'zh'
      break
    case 'zh_TW':
      editorLanguage = 'zh-hant'
      break
    default:
      editorLanguage = 'en'
      break
  }
  return editorLanguage
}

//16进度颜色转成rgba 标签颜色取背景色的.16透明度
const color2Rgba = (str = '', opacity = '1') => {
  var sColor = str.toLowerCase()
  if (sColor) {
    if (sColor.length === 4) {
      var sColorNew = '#'
      for (var i = 1; i < 4; i += 1) {
        sColorNew += sColor
            .slice(i, i + 1)
            .concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    //处理六位的颜色值
    var sColorChange = []
    for (var i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
    }
    return 'rgba(' + sColorChange.join(',') + ',' + opacity + ')'
  } else {
    return sColor
  }
}

export { color2Rgba }

// 时区
export const timeZoneDictList = [
  { timezoneValue: 'GMT-01:00', timezoneId: 'GMT-01:00' },
  { timezoneValue: 'GMT-02:00', timezoneId: 'GMT-02:00' },
  { timezoneValue: 'GMT-03:00', timezoneId: 'GMT-03:00' },
  { timezoneValue: 'GMT-04:00', timezoneId: 'GMT-04:00' },
  { timezoneValue: 'GMT-05:00', timezoneId: 'GMT-05:00' },
  { timezoneValue: 'GMT-06:00', timezoneId: 'GMT-06:00' },
  { timezoneValue: 'GMT-07:00', timezoneId: 'GMT-07:00' },
  { timezoneValue: 'GMT-08:00', timezoneId: 'GMT-08:00' },
  { timezoneValue: 'GMT-09:00', timezoneId: 'GMT-09:00' },
  { timezoneValue: 'GMT-10:00', timezoneId: 'GMT-10:00' },
  { timezoneValue: 'GMT-11:00', timezoneId: 'GMT-11:00' },
  { timezoneValue: 'GMT-12:00', timezoneId: 'GMT-12:00' },
  { timezoneValue: 'GMT+00:00', timezoneId: 'GMT+00:00' },
  { timezoneValue: 'GMT+01:00', timezoneId: 'GMT+01:00' },
  { timezoneValue: 'GMT+02:00', timezoneId: 'GMT+02:00' },
  { timezoneValue: 'GMT+03:00', timezoneId: 'GMT+03:00' },
  { timezoneValue: 'GMT+04:00', timezoneId: 'GMT+04:00' },
  { timezoneValue: 'GMT+05:00', timezoneId: 'GMT+05:00' },
  { timezoneValue: 'GMT+06:00', timezoneId: 'GMT+06:00' },
  { timezoneValue: 'GMT+07:00', timezoneId: 'GMT+07:00' },
  { timezoneValue: 'GMT+08:00', timezoneId: 'GMT+08:00' },
  { timezoneValue: 'GMT+09:00', timezoneId: 'GMT+09:00' },
  { timezoneValue: 'GMT+10:00', timezoneId: 'GMT+10:00' },
  { timezoneValue: 'GMT+11:00', timezoneId: 'GMT+11:00' },
  { timezoneValue: 'GMT+12:00', timezoneId: 'GMT+12:00' }
]

export const ticketStatusConfig = {
  1: {
    statusType: 1,
    type: 'notAccepted',
    color: '#f3303a',
    background: '#fff1f0',
    borderColor: '#ffa39e',
    customerStatusCode: 1,
    cusColor: '#fa8314',
    cusBackground: '#fff5e3'
  },
  2: {
    statusType: 2,
    type: 'accepting',
    color: '#fa8314',
    background: '#fffbe6',
    borderColor: '#ffe58f',
    customerStatusCode: 1,
    cusColor: '#fa8314',
    cusBackground: '#fff5e3'
  },
  3: {
    statusType: 3,
    type: 'waitingReply',
    color: '#2d85ec',
    background: '#e6f7ff',
    borderColor: '#91d5ff',
    customerStatusCode: 2,
    cusColor: '#2d85ec',
    cusBackground: '#e6f7ff'
  },
  4: {
    statusType: 4,
    type: 'paused',
    color: '#0daeaf',
    background: '#e7fefc',
    borderColor: '#86e4df',
    customerStatusCode: 1,
    cusColor: '#fa8314',
    cusBackground: '#fff5e3'
  },
  5: {
    statusType: 5,
    type: 'resolved',
    color: '#52c41a',
    background: '#f6ffed',
    borderColor: '#b7eb8f',
    customerStatusCode: 3,
    cusColor: '#52c41a',
    cusBackground: '#F2FFE6'
  },
  6: {
    statusType: 6,
    type: 'closed',
    color: '#161616',
    background: '#f8f9fa',
    borderColor: 'rgba(0, 0, 0, 0.06)',
    customerStatusCode: 3,
    cusColor: '#52c41a',
    cusBackground: '#F2FFE6'
  },
  7: {
    statusType: 7,
    type: 'deleted',
    color: '#999999',
    background: '#edeff2',
    borderColor: '#c9cbcd',
    customerStatusCode: 4,
    cusColor: '#999999',
    cusBackground: '#edeff2'
  }
}

export const getTicketStatusConfig = (ticketStatus, statusTypeMap = []) => {
  if (!Array.isArray(statusTypeMap)) return {}
  const config =
    statusTypeMap.find(
      (item) => Number(item.statusCode) === Number(ticketStatus)
    ) || null
  if (!config) return {}
  return { ...config, ...(ticketStatusConfig[config.statusType] || {}) }
}

export const formatHeaders = (header = {}) => {
  const config = {}
  Object.entries(header).forEach(([k, v]) => {
    if (v != null && v !== '') {
      config[k] = v
    }
  })
  return config
}
